import { useState, useEffect } from "react";

export interface IUseImageSize {
  imageData: string; // base64
}

export const useImageSize = (props: IUseImageSize) => {
  const { imageData } = props;

  const [height, setHeight] = useState(1200);
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    const t = imageData?.trim();
    if (!t) return;

    const img = new Image();
    let cancelled = false;

    img.onload = () => {
      if (cancelled) return;
      const nw = img.naturalWidth || img.width;
      const nh = img.naturalHeight || img.height;
      if (nw > 0 && nh > 0) {
        setWidth(nw);
        setHeight(nh);
      }
    };

    img.onerror = () => {};

    img.src = `data:image/jpeg;charset=utf-8;base64,${t}`;

    return () => {
      cancelled = true;
      img.onload = null;
      img.onerror = null;
    };
  }, [imageData]);

  return { height, width };
};
